export default __webpack_public_path__ + "static/fabian-schulze-4ead3fad5272ab717d00fd12c7b26b3c.png";